import useSWR from "swr";
import axios from "axios";

function useLicenseTypes({ page, perPage, showArchived }) {
  return useSWR([
    `${process.env.REACT_APP_API_URL}/license-types`, page, perPage, showArchived
  ], async ([url, page, perPage, showArchived]) => {
    const params = new URLSearchParams();

    if (page) params.append('page', page);
    if (perPage) params.append('perPage', perPage);
    if (showArchived) params.append('showArchived', showArchived);

    const { data: { licenseTypes, count } } = await axios.get(`${url}?${params.toString()}`);

    return { licenseTypes, count };
  });
}

export default useLicenseTypes;
